/* eslint-disable no-unused-vars */

export default (i18n, admin,store) => [
  {
    icon: "mdi-view-dashboard",
    text: i18n.t("menu.landing"),
    name: "landing",
    link: "/admin/landing/"+store.getters.authen.locale,
  },
  {
    icon: "mdi-view-dashboard",
    text: i18n.t("menu.slide"),
    name: "Slide",
    link: "/admin/slide/"+store.getters.authen.locale,
  },
  {
    icon: "mdi-view-dashboard",
    text: i18n.t("menu.aboutus"),
    name: "AboutUs",
    link: "/admin/aboutus/"+store.getters.authen.locale, 
  },
  {
    icon: "mdi-view-dashboard",
    text: i18n.t("menu.award"),
    name: "Award",
    link: "/admin/award/"+store.getters.authen.locale,
  },
  {
    icon: "mdi-view-dashboard",
    text: i18n.t("menu.business"),
    name: "BusinessGroup",
    link: "/admin/businessgroup/"+store.getters.authen.locale,
  },
  {
    icon: "mdi-view-dashboard",
    text: i18n.t("menu.news"),
    name: "News",
    link: "/admin/news/"+store.getters.authen.locale,
  },
  {
    icon: "mdi-view-dashboard",
    text: i18n.t("menu.ceo"),
    link: "/admin/ceo/"+store.getters.authen.locale,
  },
  {
    icon: "mdi-view-dashboard",
    text: i18n.t("menu.contactus"),
    link: "/admin/contactus/"+store.getters.authen.locale,
  },
  { divider: true },
];
